<template>
  <div>
		<div class="mgt-200 t-center">
        <img alt="" class="no-degree-image mgx-auto" src="/images/no-degree-data-image.svg">
    </div>
    <div v-for="tab in tabs" :key="tab.status">
      <div v-if="statusTab === tab.status" class="mgt-24 t-center t-headline8 font-r">{{ $t(tab.headline) }}</div>
      <div v-if="statusTab === tab.status" class="mgt-4 t-center t-body1 t-color-bodyGrayA">{{ $t(tab.body) }}</div>
    </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      statusTab: null,
      tabs: [
        {
          status: 'LEARNING',
          headline: '3206',
          body: '3207',
        },
        {
          status: 'WAITING',
          headline: '3210',
          body: '3211',
        },
        {
          status: 'COMPLETION',
          headline: '3208',
          body: '3209',
        },
      ],
    };
  },

  watch: {
    $route(to, from) {
      this.statusTab = this.$route.query.status;
    },
  },

  mounted() {
    this.statusTab = this.$route.query.status;
  }
};
</script>

<style scoped>
.no-board-data img {
    height: 143px;
    width: auto;
}
</style>